
import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/views/layout/Layout'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '',
      component: Layout,
      redirect: 'home',
      children: [
        {
          alias: '',
          path: 'home',
          component: () => import('@/views/home/index'),
          name: 'Home',
          meta: { title: 'Home'}
        },
        {
          path: 'product',
          component: () => import('@/views/home/product'),
          name: 'Products',
          meta: { title: 'Products'}
        },
        {
          path: 'company',
          component: () => import('@/views/home/company'),
          name: 'Company',
          meta: { title: 'Company'}
        },
        {
          path: 'contact',
          component: () => import('@/views/home/contact'),
          name: 'ContactUs',
          meta: { title: 'Contact Us'}
        }
      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js